import styled from "@emotion/styled";

export const Row = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: ${({ columns }) =>
    columns && columns > 1 ? `repeat(${columns}, 1fr)` : "1fr"};
  gap: ${({ theme }) => theme.space.space16};

  &.sub {
    gap: ${({ theme }) => theme.space.space8};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    &:not(.sub) {
      grid-template-columns: 1fr;
      grid-template-rows: ${({ columns }) =>
        columns && columns > 1 ? `repeat(${columns}, 1fr)` : "1fr"};
    }
  }
`;
